// Obtén todos los elementos hijos con la clase 'upsell-package'
let upsellPackages = document.querySelectorAll('.product__block__upsell-product_package .upsell-package');

// Re-measure the main product gallery (Flickity) to its current image height.
// flickity-lock-height freezes the viewport to the cell height measured on load;
// after an upsell-package click reflows the page the locked height no longer
// matches the active image, which crops it. Removing the lock class and calling
// resize() forces Flickity to re-measure to the full image height.
function resizeProductGallery() {
    const slideshow = document.querySelector('.product__grid--slides');
    if (!slideshow) return;

    const viewport = slideshow.querySelector('.flickity-viewport');
    if (!viewport) return;

    // Pin the viewport to its CURRENT rendered height before touching the lock,
    // so removing flickity-lock-height can't collapse it to a stale/smaller value
    // (that collapse is what caused the visible shrink-then-grow glitch). The pin
    // holds the height until the new image is ready, then we measure once.
    viewport.style.minHeight = viewport.offsetHeight + 'px';

    const measure = () => {
        // Drop the lock so the viewport stops using --default-ratio (first-image
        // ratio) and falls back to Flickity's adaptiveHeight = real image height.
        slideshow.classList.remove('flickity-lock-height');

        // Prefer the Flickity instance API if the global is exposed; otherwise a
        // window resize event triggers Flickity's own resize listener.
        const flkty = (typeof Flickity !== 'undefined' && Flickity.data)
            ? Flickity.data(slideshow)
            : null;
        if (flkty) {
            flkty.resize();
        } else {
            window.dispatchEvent(new Event('resize'));
        }

        // Release the pin so the viewport settles to the measured image height.
        viewport.style.minHeight = '';
    };

    // Measure only once — when the active image is actually ready — so there is a
    // single height change instead of an early collapse followed by a regrow.
    const activeImg = slideshow.querySelector('.is-selected img, .product__media img');
    if (activeImg && !activeImg.complete) {
        activeImg.addEventListener('load', measure, { once: true });
    } else {
        requestAnimationFrame(measure);
    }
}

// Función para actualizar visibilidad del botón Add to bag
function updateAddToBagButton(package) {
    const addToBagButton = document.getElementById('btn-addcart-smg');
    const productSubmitButtons = document.querySelector('.product__submit__buttons');
    const shopPayButton = document.querySelector('.product__submit__quick');
    const isAvailable = (package.getAttribute('data-variant-available') ?? package.getAttribute('available')) === 'true';
    
    if (addToBagButton) {
        addToBagButton.style.display = isAvailable ? 'block' : 'none';
        console.log('disponible', isAvailable)
        if (isAvailable) {
            addToBagButton.removeAttribute('disabled');
            // Keep the buttons wrapper visible (it holds Shop Pay + More payment options)
            if (productSubmitButtons) {
                productSubmitButtons.style.display = 'block';
                // Hide native add button only — Shop Pay stays
                const nativeAddBtn = productSubmitButtons.querySelector('product-add-button');
                if (nativeAddBtn) nativeAddBtn.style.display = 'none';
            }
            // Ensure Shop Pay / dynamic checkout container is visible
            if (shopPayButton) shopPayButton.style.display = 'block';
        } else {
            addToBagButton.setAttribute('disabled', 'disabled');
            // Restore native add button and Shop Pay
            if (productSubmitButtons) {
                const nativeAddBtn = productSubmitButtons.querySelector('product-add-button');
                if (nativeAddBtn) nativeAddBtn.style.display = '';
            }
            if (shopPayButton) shopPayButton.style.display = 'block';
        }
    }
}

function isTwoPersonPackage(package) {
    if (!package) return false;

    const handle = package.getAttribute('handle') || '';
    const title = package.querySelector('h5')?.textContent || '';
    const label = `${handle} ${title}`.toLowerCase();

    return label.includes('2-person') || label.includes('2 person') || label.includes('two-person') || label.includes('two person');
}

function isOnePersonPackage(package) {
    if (!package) return false;

    const handle = package.getAttribute('handle') || '';
    const title = package.querySelector('h5')?.textContent || '';
    const label = `${handle} ${title}`.toLowerCase();

    return label.includes('1-person') || label.includes('1 person') || label.includes('one-person') || label.includes('one person');
}

function updateColorSwatchVisibility(package) {
    const colorSwatches = document.querySelectorAll('[data-color-swatch-wrapper], .selector-wrapper--color');
    if (!colorSwatches.length) return;

    const shouldHide = isTwoPersonPackage(package);
    colorSwatches.forEach((swatch) => {
        swatch.hidden = shouldHide;
    });
}

function normalizeOptionValue(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
}

function getSelectedColorValue() {
    const checkedColor = document.querySelector('[data-color-swatch-wrapper] input[type="radio"]:checked, .selector-wrapper--color input[type="radio"]:checked');
    return checkedColor ? checkedColor.value : '';
}

function getPackageData(package) {
    const productId = package?.getAttribute('prd');
    const dataScript = productId ? document.querySelector('script[id="'+productId+'"]') : null;
    if (!dataScript) return null;

    try {
        return JSON.parse(dataScript.textContent);
    } catch (error) {
        console.error('Error al parsear variantes del paquete:', error);
        return null;
    }
}

function getVariantImageSrc(variant) {
    const featuredImage = variant?.featured_image;
    if (!featuredImage) return '';

    return typeof featuredImage === 'string' ? featuredImage : featuredImage.src;
}

function imageUrlWithWidth(src, width) {
    if (!src) return '';

    const separator = src.includes('?') ? '&' : '?';
    return `${src}${separator}width=${width}`;
}

function findVariantByColor(packageData, color) {
    if (!packageData?.variants?.length || !color) return null;

    const selectedColor = normalizeOptionValue(color);
    const colorIndex = (packageData.options || []).findIndex((optionName) => {
        const normalizedName = normalizeOptionValue(optionName);
        return normalizedName === 'color' || normalizedName === 'colour';
    });

    return packageData.variants.find((variant) => {
        if (!variant.options) return false;

        if (colorIndex >= 0) {
            return normalizeOptionValue(variant.options[colorIndex]) === selectedColor;
        }

        return variant.options.some((optionValue) => normalizeOptionValue(optionValue) === selectedColor);
    });
}

function updatePackageInputs(package, variant) {
    if (!package.classList.contains('active')) return;

    document.querySelectorAll('input[name="id"]').forEach((input) => {
        input.value = variant.id;
        input.setAttribute('value', variant.id);
    });
}

function updateOnePersonPackageForSelectedColor() {
    const selectedColor = getSelectedColorValue();
    if (!selectedColor) return;

    const packages = Array.from(document.querySelectorAll('.product__block__upsell-product_package .upsell-package'));
    const onePersonPackage = packages.find(isOnePersonPackage) || packages.find((package) => !isTwoPersonPackage(package));
    if (!onePersonPackage) return;

    const packageData = getPackageData(onePersonPackage);
    const colorVariant = findVariantByColor(packageData, selectedColor);
    if (!colorVariant) return;

    const imageSrc = getVariantImageSrc(colorVariant);
    const packageImage = onePersonPackage.querySelector('.upsell-package_image');

    if (packageImage && imageSrc) {
        packageImage.src = imageUrlWithWidth(imageSrc, 300);
    }

    onePersonPackage.setAttribute('data-upsell-package-pro', colorVariant.id);
    onePersonPackage.setAttribute('data-variant-available', String(colorVariant.available));
    onePersonPackage.setAttribute('price', colorVariant.price);
    onePersonPackage.setAttribute('compare_at_price', colorVariant.compare_at_price);

    const priceEl = onePersonPackage.querySelector('.discounted-price');
    const compareAtPriceEl = onePersonPackage.querySelector('.initial-price');
    if (priceEl) {
        priceEl.textContent = colorVariant.price;
        priceEl.setAttribute('data-variant-id', colorVariant.id);
    }
    if (compareAtPriceEl) {
        compareAtPriceEl.textContent = colorVariant.compare_at_price;
        compareAtPriceEl.setAttribute('data-variant-id', colorVariant.id);
    }

    if (onePersonPackage.classList.contains('active')) {
        const productPrice = document.querySelector('.product__price [data-product-price], span.product__price span');
        if (productPrice) {
            productPrice.textContent = colorVariant.price;
        }
        updateAddToBagButton(onePersonPackage);
    }

    updatePackageInputs(onePersonPackage, colorVariant);
}

// Añade un event listener a cada elemento
upsellPackages.forEach(function(package) {
    package.addEventListener('click', function(evt) {
        // Busca el elemento con la clase 'active' y remuévela
        let activeElement = document.querySelector('.product__block__upsell-product_package .active'),
        divElement = document.querySelectorAll('.product__block__upsell-product');
        if (activeElement) {
            activeElement.classList.remove('active');
        }

        // Añade la clase 'active' al elemento que se le dio click
        this.classList.add('active');

        // Actualiza la visibilidad del botón Add to bag
        updateAddToBagButton(this);
        updateColorSwatchVisibility(this);

        // Actualizar la descripción corta si existe
        const modelId = this.getAttribute('prd');
        if (modelId && document.querySelector('script[id="'+modelId+'"]')) {
            // Usar try-catch para manejar posibles errores de parsing JSON
            let modelMetafields;
            try {
                modelMetafields = JSON.parse(document.querySelector('script[id="'+modelId+'"]').textContent);
                console.log('JSON parseado correctamente');
            } catch (error) {
                console.error('Error al parsear JSON:', error);
                console.log('JSON con error:', document.querySelector('script[id="'+modelId+'"]').textContent);
                return; // Salir si hay error de parsing
            }
            if (modelMetafields.short_description_product && document.querySelector('.product__block__short-description')) {
                // Crear un elemento temporal para extraer solo el texto
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = modelMetafields.short_description_product;
                
                // Buscar el texto dentro de cualquier estructura HTML
                let textContent = '';
                const paragraphs = tempDiv.querySelectorAll('p');
                
                if (paragraphs.length > 0) {
                    // Si hay párrafos, extraer su contenido
                    paragraphs.forEach(p => {
                        textContent += '<p>' + p.innerHTML + '</p>';
                    });
                } else {
                    // Si no hay párrafos, usar el texto plano
                    textContent = tempDiv.textContent;
                }
                
                document.querySelector('.product__block__short-description').innerHTML = textContent;
                console.log('Descripción corta actualizada para:', modelId);
            }
            
            // Actualizar key_features si existe
            if (modelMetafields.key_features && document.querySelector('.feature-list')) {
                // Crear un elemento temporal para extraer el contenido HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = modelMetafields.key_features;
                
                // Debug: mostrar el contenido original
                console.log('Contenido original de key_features:', modelMetafields.key_features);
                
                // Procesar las características
                let featuresContent = '';
                
                // Obtener el contenido y dividirlo por <br>
                const rawContent = tempDiv.innerHTML;
                console.log('Contenido HTML procesado:', rawContent);
                
                // Dividir por <br> y filtrar líneas vacías
                let features = rawContent.split('<br>');
                console.log('Features después de split:', features);
                
                // Filtrar elementos vacíos y etiquetas HTML sueltas
                features = features.filter(feature => {
                    const trimmed = feature.trim();
                    // Filtrar elementos vacíos y etiquetas de cierre sueltas como </span>
                    return trimmed !== '' && !trimmed.match(/^\s*<\/[^>]+>\s*$/); 
                });
                console.log('Features después de filtrar:', features);
                
                // Generar el HTML solo para elementos no vacíos
                if (features.length > 0) {
                    features.forEach(feature => {
                        const trimmedFeature = feature.trim();
                        if (trimmedFeature) {
                            featuresContent += `
                            <li style="margin-bottom: 10px;">
                              <p style="display: flex; align-items: flex-start;">
                                <span style="margin-right: 8px;">&rarr;</span>
                                <span>${trimmedFeature}</span>
                              </p>
                            </li>`;
                        }
                    });
                }
                
                // Actualizar el contenido solo si hay características
                document.querySelector('.feature-list').innerHTML = featuresContent;
                console.log('Key features actualizadas para:', modelId);
            }
        }

        if(divElement.length > 0 && divElement[0].classList.contains('package-template')) {
            console.log('cargando chiller desde', divElement);
            // packages chiller method
            let id = this.getAttribute('prd'),
            variant = this.getAttribute('variant'),
            available = this.getAttribute('available'),
            price = evt.currentTarget.getAttribute('price'),
            compareAtPrice = evt.currentTarget.getAttribute('compare_at_price'),
            metafields = JSON.parse(document.querySelector('script[id="'+id+'"]').textContent),
            tabActive = document.querySelector('.product-selector-type_tabs .tab.active');
    
            let getURL = new URL(window.location.href),
            params = getURL.searchParams;
    
            getURL.searchParams.delete('model');
            getURL.searchParams.delete('type');
            getURL.searchParams.set('model', id);
            getURL.searchParams.set('type', document.querySelector('.product-selector-type_tabs .tab.active').getAttribute('type'));
        
            window.history.pushState(null,null, getURL);
    
            document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('packages_id', id)
            document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('variant_id', metafields.package_variant_id);
            document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('price', metafields.package_price);
            document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('total_price', metafields.total_price_sum);
            document.querySelector('.product-selector-type_tabs .tab[type="no"]').setAttribute('packages_id', id);
            document.querySelector('.product-selector-type_tabs .tab[type="no"]').setAttribute('price', metafields.model_price);
            document.querySelector('.product-selector-type_tabs .tab[type="no"]').setAttribute('handle', metafields.model_handle);
            document.querySelector('.product-selector-type_tabs .tab[type="yes"]').setAttribute('handle', metafields.package_handle);
    
            document.querySelector('.product-selector-type_tabs').setAttribute('product_id', id);
            document.querySelector('.product-selector-type_tabs').setAttribute('variant_id', variant);
    
            if(tabActive.getAttribute('type') == 'yes') {
                price = document.querySelector('.product-selector-type_tabs .tab[type="yes"]').getAttribute('total_price');
            }
            setTimeout(() => {
                price = document.querySelector('.product-selector-type_tabs .tab.active').getAttribute('price');
                document.querySelector('.product__price').innerHTML = `
                    <span data-product-price>${price}</span>
                `;
                document.querySelector('.product__price').dataset.variantId = variant;

                if(document.querySelectorAll('.product__price__main .product__price--off').length > 0) {
                    document.querySelector('.product__price__main .product__price--off span:not([data-price-off-type])').innerHTML = compareAtPrice;
                    document.querySelector('.product__price__main .product__price--off span:not([data-price-off-type])').dataset.variantId = variant;
                }

            }, 200);
    
    
            let submitButtons = document.querySelector('.product__submit__buttons product-add-button');
            console.log(available);

            if(document.querySelectorAll('.product-selector-type_tabs.megatabs').length > 0) {
                available = document.querySelector('.product-selector-type_tabs.megatabs').getAttribute('available');
            }

            if(available == 'false') {
                console.log(document.querySelectorAll('button[id="btn-addcart"].ng'));
                document.querySelector('button[id="btn-addcart-smg"]').style.display = 'none';
    
                submitButtons.setAttribute('style', '');
            } else {
                submitButtons.setAttribute('style', 'display: none');
                document.querySelector('button[id="btn-addcart-smg"]').style.display = 'block';
            }

        } else {
            let compareAtPrice = evt.currentTarget.getAttribute('compare_at_price'),
            price = evt.currentTarget.getAttribute('price');

            document.querySelector('span.product__price span').innerHTML = price;
            document.querySelector('.product__price [data-product-price]').dataset.variantId = evt.currentTarget.getAttribute('data-upsell-package-pro');

            if(document.querySelectorAll('.product__price__main .product__price--off').length > 0) {
                document.querySelector('.product__price__main .product__price--off span:not([data-price-off-type])').innerHTML = compareAtPrice;
                document.querySelector('.product__price__main .product__price--off span:not([data-price-off-type])').dataset.variantId = evt.currentTarget.getAttribute('data-upsell-package-pro');
            }
        }
        let getVariant = evt.currentTarget.getAttribute('data-upsell-package-pro');
        console.log('package pro', getVariant);
        if(getVariant != '') {
            document.querySelectorAll('input[name="id"]').forEach((input) => {
                input.value = getVariant;
                input.setAttribute('value', getVariant);
            })
        }

        // Re-measure the product gallery so it keeps full height after the
        // package click reflows the layout (otherwise flickity-lock-height keeps
        // the old cell height and crops the active image).
        resizeProductGallery();
    });

    setTimeout(() => {
        let _divElement = document.querySelectorAll('.product__block__upsell-product:not(.package-template)');
        if(_divElement.length > 0) {
            console.log('si hay cargado', _divElement.length)
            _divElement.forEach((item) => {
                //if(!item.classList.contains('package-template')) {
                    let packageActive = document.querySelector('.product__block__upsell-product_package .upsell-package.active'),
                    featuredImage = packageActive.querySelector('img').getAttribute('src'),
                    slides = document.querySelectorAll('.product__grid--slides .flickity-slider .product__media.flickity-cell'),
                    thumbs = document.querySelectorAll('.media__thumb__holder .media__thumb__wrapper .media__thumb');
    
                    if(slides.length > 0) {
                        slides.forEach((_slide) => {
                            if(_slide.getAttribute('super_image_smg') == 'test') {
                            document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="test"] img').setAttribute('srcset', `
                                ${featuredImage}&amp;width=352 352w,  ${featuredImage}?v=1708818227&amp;width=400 400w,  ${featuredImage}?v=1708818227&amp;width=768 768w,  ${featuredImage}?v=1708818227&amp;width=932 932w,  ${featuredImage}?v=1708818227&amp;width=1024 1024w,  ${featuredImage}?v=1708818227&amp;width=1200 1200w,  ${featuredImage}?v=1708818227&amp;width=1920 1920w, ${featuredImage}?v=1708818227&amp;width=2707 2707w
                            `);
                            document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="test"] img').setAttribute('sizes', '(min-width: 1100px) 70vw, (min-width: 768px) 50vw, calc(85vw - 20px)');
                            document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="test"] img').setAttribute('src', featuredImage)
                            document.querySelector('.product__grid--slides .flickity-slider .product__media[super_image_smg="test"]').setAttribute('data-media-src-placeholder', featuredImage);
                            }
                        })
                    }
    
                    /*if(thumbs.length > 0) {
                        thumbs.forEach((_thumb) => {
                            if(_thumb.getAttribute('super_image_smg') == 'test') {
                            document.querySelector('.media__thumb__holder .media__thumb__wrapper .media__thumb[super_image_smg="test"] img').setAttribute('src', featuredImage);
                            //_thumb.click();
                            }
                        });
                    }*/
                //}
            });
        }
    }, 900);
});

const replaceQueryParam = (param, newval, search) => {
    var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
    var query = search.replace(regex, "$1").replace(/&$/, '');

    return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
}

document.addEventListener('DOMContentLoaded', () => {
    updateOnePersonPackageForSelectedColor();

    const syncOnePersonPackageAfterThemeUpdate = () => {
        setTimeout(updateOnePersonPackageForSelectedColor, 0);
    };

    document.querySelectorAll('[data-color-swatch-wrapper] input[type="radio"], .selector-wrapper--color input[type="radio"]').forEach((input) => {
        input.addEventListener('change', syncOnePersonPackageAfterThemeUpdate);
    });
    document.addEventListener('theme:variant:change', syncOnePersonPackageAfterThemeUpdate);

    // Inicializar el estado del botón Add to bag para el producto activo inicial
    const activePackage = document.querySelector('.product__block__upsell-product_package .upsell-package.active');
    if (activePackage) {
        updateAddToBagButton(activePackage);
        updateColorSwatchVisibility(activePackage);
        
        // Actualizar la descripción corta al cargar la página
        const modelId = activePackage.getAttribute('prd');
        if (modelId && document.querySelector('script[id="'+modelId+'"]')) {
            // Usar try-catch para manejar posibles errores de parsing JSON
            let modelMetafields;
            try {
                modelMetafields = JSON.parse(document.querySelector('script[id="'+modelId+'"]').textContent);
                console.log('JSON inicial parseado correctamente');
            } catch (error) {
                console.error('Error al parsear JSON inicial:', error);
                console.log('JSON con error:', document.querySelector('script[id="'+modelId+'"]').textContent);
                return; // Salir si hay error de parsing
            }
            if (modelMetafields.short_description_product && document.querySelector('.product__block__short-description')) {
                // Crear un elemento temporal para extraer solo el texto
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = modelMetafields.short_description_product;
                
                // Buscar el texto dentro de cualquier estructura HTML
                let textContent = '';
                const paragraphs = tempDiv.querySelectorAll('p');
                
                if (paragraphs.length > 0) {
                    // Si hay párrafos, extraer su contenido
                    paragraphs.forEach(p => {
                        textContent += '<p>' + p.innerHTML + '</p>';
                    });
                } else {
                    // Si no hay párrafos, usar el texto plano
                    textContent = tempDiv.textContent;
                }
                
                document.querySelector('.product__block__short-description').innerHTML = textContent;
                console.log('Descripción corta inicializada para:', modelId);
            }
            
            // Inicializar key_features si existe
            if (modelMetafields.key_features && document.querySelector('.feature-list')) {
                // Crear un elemento temporal para extraer el contenido HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = modelMetafields.key_features;
                
                // Debug: mostrar el contenido original
                console.log('Contenido original de key_features (inicial):', modelMetafields.key_features);
                
                // Procesar las características
                let featuresContent = '';
                
                // Obtener el contenido y dividirlo por <br>
                const rawContent = tempDiv.innerHTML;
                console.log('Contenido HTML procesado (inicial):', rawContent);
                
                // Dividir por <br> y filtrar líneas vacías
                let features = rawContent.split('<br>');
                console.log('Features después de split (inicial):', features);
                
                // Filtrar elementos vacíos y etiquetas HTML sueltas
                features = features.filter(feature => {
                    const trimmed = feature.trim();
                    // Filtrar elementos vacíos y etiquetas de cierre sueltas como </span>
                    return trimmed !== '' && !trimmed.match(/^\s*<\/[^>]+>\s*$/); 
                });
                console.log('Features después de filtrar (inicial):', features);
                
                // Generar el HTML solo para elementos no vacíos
                if (features.length > 0) {
                    features.forEach(feature => {
                        const trimmedFeature = feature.trim();
                        if (trimmedFeature) {
                            featuresContent += `
                            <li style="margin-bottom: 10px;">
                              <p style="display: flex; align-items: flex-start;">
                                <span style="margin-right: 8px;">&rarr;</span>
                                <span>${trimmedFeature}</span>
                              </p>
                            </li>`;
                        }
                    });
                }
                
                // Actualizar el contenido solo si hay características
                document.querySelector('.feature-list').innerHTML = featuresContent;
                console.log('Key features inicializadas para:', modelId);
            }
        }
    }

    let divElement = document.querySelectorAll('.product__block__upsell-product');
    if(divElement.length > 0 && divElement[0].classList.contains('package-template')) {
        console.log('testing up')
        const openModal = document.querySelector('.open_modal-pro_icepod');
        const productModal = document.querySelector('.product-modal-pro_icepod');
        const productModalContainer = document.querySelector('.product-modal-pro_icepod-section');
        const pro_icepodCloseModal = document.querySelector('.product-modal-pro_icepod-section .close-modal');

        console.log('open-modal', openModal)
    
        openModal.addEventListener('click', () => {
            console.log('clickeado')
            productModal.classList.add('active');
        });
    
        productModal.addEventListener('click', (event) => {
            if(productModal.classList.contains('active') && !productModalContainer.contains(event.target)){
                productModal.classList.remove('active');
            }
    
            if(pro_icepodCloseModal.contains(event.target)) {
                productModal.classList.remove('active');
            }
        })
    }
});

document.addEventListener('DOMContentLoaded', () => {
    let divElement = document.querySelectorAll('.product__block__upsell-product');
    if(divElement.length > 0 && divElement[0].classList.contains('package-template')) {
        const openModal_chiller = document.querySelector('.open_modal-chiller');
        const productModal_chiller = document.querySelector('.product-modal-chiller_section');
        const productModalContainer_chiller = document.querySelector('.product-modal-chiller_container');
        const pro_icepodCloseModal_chiller = document.querySelector('.product-modal-chiller_section .close-modal');
        const pro_icepodCloseModal_chillerTow = document.querySelector('.product-modal-chiller_section .btn-close-modal');
        const openModalTab = document.querySelector('.product-selector-type_tabs_body .open-modal');
        const modalChiller = document.querySelectorAll('.product-modal-chiller_container .modal-accordion-list .modal-accordion-item');
        
        console.log('el modal es', openModalTab);

        modalChiller.forEach(item => {
            const modalChillerBtn = item.querySelector('.title-item');
            const modalChillerText = item.querySelector('.list-description-item');
            const maxHeight = (modalChillerText.scrollHeight + 130) + 'px'; // Calcula la altura del contenido
    
            modalChillerBtn.addEventListener('click', () => {
                if (item.classList.contains('active')) {
                item.classList.remove('active');
                modalChillerText.style.maxHeight = '0'; // Cierra el elemento
                } else {
                modalChiller.forEach(otherItem => {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.list-description-item').style.maxHeight = '0'; // Cierra otros elementos
                });
                item.classList.add('active');
                modalChillerText.style.maxHeight = maxHeight; // Abre el elemento actual
                }
            });
        });
    
        productModal_chiller.style.display = 'none'
    
        openModal_chiller.addEventListener('click', () => {
            productModal_chiller.classList.add('active');
            productModal_chiller.style.display = 'flex'
        });
    
        document.querySelector('.product-selector-type_tabs_body .open-modal').addEventListener('click', () => {
            console.log('fue clickeado');
            productModal_chiller.classList.add('active');
            productModal_chiller.style.display = 'flex'
        });
    
        productModal_chiller.addEventListener('click', (event) => {
            if(productModal_chiller.classList.contains('active') && !productModalContainer_chiller.contains(event.target)){
                productModal_chiller.classList.remove('active');
                productModal_chiller.style.display = 'none'
            }
    
            if(pro_icepodCloseModal_chiller.contains(event.target)) {
                productModal_chiller.classList.remove('active');
                productModal_chiller.style.display = 'none'
            }
    
            if(pro_icepodCloseModal_chillerTow.contains(event.target)) {
                productModal_chiller.classList.remove('active');
                productModal_chiller.style.display = 'none'
            }
        })
    }
});
